import {
    createRouter,
    createWebHistory
} from 'vue-router'
import HomeView from '../views/HomeView.vue'
import FlightSearchResultView from '../views/FlightSearchResultView.vue'
import FlightPassengersView from '../views/FlightPassengersView.vue'
import FlightConfirmationView from '../views/FlightConfirmationView.vue'
import FlightPoliciesView from '../views/FlightPoliciesView.vue'
import ErrorView from '../views/ErrorView.vue'
import BookingHelpView from '../views/BookingHelpView.vue'
import BookingDetailsView from '../views/BookingDetailsView.vue'
import BookingHelpDetailsView from '../views/BookingHelpDetailsView.vue'
import guestNeedHelpMiddleware from '@/middleware/guestNeedHelpMiddleware'
import guestNeedHelpDetailsMiddleware from '@/middleware/guestNeedHelpDetailsMiddleware'
import NoFlightConfirmation from '../views/NoFlightConfirmationView.vue'

const routes = [{
        path: '/',
        name: 'home',
        component: HomeView
    },
    {
        path: '/flight-search-result',
        name: 'flight-search-result',
        component: FlightSearchResultView
    },
    {
        path: '/flight-passengers',
        name: 'flight-passengers',
        component: FlightPassengersView
    },
    {
        path: '/flight-confirmation/:checkoutId?',
        name: 'flight-confirmation',
        component: FlightConfirmationView
    },
    {
        path: '/no-flights-confirmation/:checkoutId?',
        name: 'no-flight-confirmation',
        component: NoFlightConfirmation
    },
    {
        path: '/flight-policies/:id',
        name: 'flight-booking-policies',
        component: FlightPoliciesView
    },
    {
        path: '/booking-help',
        name: 'booking-help',
        component: BookingHelpView,
        beforeEnter: guestNeedHelpMiddleware,
    },
    {
        path: '/booking-help-details',
        name: 'booking-help-details',
        component: BookingHelpDetailsView,
        beforeEnter: guestNeedHelpDetailsMiddleware,
    },
    {
        path: '/booking-details',
        name: 'booking-details',
        component: BookingDetailsView
    },
    {
        path: '/error',
        name: 'error',
        component: ErrorView
    },
    {
        path: '/:cathAll(.*)',
        name: 'NotFound',
        component: ErrorView
    }
]


const scrollBehavior = (to, from, savedPosition) => {
    return savedPosition ||
        to.meta.scrollPos || {
            top: 0,
            left: 0
        }
}

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior,
})

router.beforeEach((to, from, next) => {
    from.meta.scrollPos && (from.meta.scrollPos.top = window.scrollY)
    return next()
})

export default router